require('intersection-observer')
import React, { useState, useRef } from 'react'
import './image.scss'
import classNames from 'classnames'
import useVisibility from 'react-intersection-visible-hook'

export default ({ children, hideCopyright = false, image, forceProperty, className, style, ...otherProps }) => {
  const [imageLoaded, setImageLoaded] = useState(false)
  const container = useRef(null)
  const visibility = useVisibility(container)
  let preferredProperty = forceProperty
  if (!forceProperty && window.innerWidth < 1000) {
    preferredProperty = 'mobile'
  }
  // find correct copyright defensively
  let copyright
  if (image && image[preferredProperty] && image[preferredProperty].copyright) {
    copyright = image[preferredProperty].copyright
  } else if (image && image.copyright) {
    copyright = image.copyright
  }
  // find correct image Url to use defensively
  let imageUrl
  if (image && image[preferredProperty] && image[preferredProperty].url) {
    imageUrl = image[preferredProperty].url
  } else if (image && image.url) {
    imageUrl = image.url
  }
  // load image if visible and not loaded yet
  if (visibility.isIntersecting && !imageLoaded) {
    const imageElement = new Image()
    imageElement.onload = () => setImageLoaded(true)
    if (imageUrl) {
      imageElement.src = imageUrl
    }
  }
  // overload classNames
  className = classNames(className, 'image-module')

  return (
    <div className={className} style={style} {...otherProps} ref={container}>
      <div
        className={`image-module-image ${imageLoaded ? 'loaded' : 'not-loaded'}`}
        style={{ backgroundImage: imageUrl ? `url(${imageUrl})` : 'none' }}
      ></div>
      {image && !imageLoaded && <div className="spinner"></div>}
      {copyright && !hideCopyright && <div className="copyright">{copyright}</div>}
      {children && <div className="image-module-inner">{children}</div>}
    </div>
  )
}
